import { Directive, Injectable } from '@angular/core';
import { FormControl, Validator, FormGroup } from '@angular/forms';

@Injectable()
export class LessThanCompareValidator implements Validator {
  validator: Function;

  constructor() {
    this.validator = LessThanCompareValidator.lessThanCompareValidatorFactory('');
  }

  validate(c: FormControl) {
    return this.validator(c);
  }

  static lessThanCompareValidatorFactory(otherControl: string) {
    return (c: FormControl) => {
      if (!c.parent || !(c.parent as FormGroup).controls) {
        return null;
      }

      if(!c.value){
        return null;
      }
      const cValue = parseFloat(c.value);
      const otherValue = parseFloat((c.parent as FormGroup).controls[otherControl].value);
      //const test = c.value <= (c.parent as FormGroup).controls[otherControl].value;
      const test = cValue <= otherValue;
      return test ? null : { lessThanInvalid: true };
    }
  }
}
